module.exports = {
  popup_hints: {
    oscillogram_view: 'Выбрать формат отображения осциллограммы', //
    download_record: 'Скачать аудиозапись', //
    record_play: 'Воспроизвести', //
    playing_speed: 'Скорость воспроизведения', //
    download_transcript: 'Скачать транскрипт', //
    copy_link: 'Копировать ссылку',
    show_close: 'Показать/скрыть',
    go_to: 'Перейти к значению',
  },
  is_no_dialog: 'Диалог отсутствует',
  soon: 'Скоро',
  recog_model: 'Модель распознавания:',
  skeleton_loading_label: 'Загрузка аудио...',
  record_not_found: 'Запись не найдена',
  audio: 'Запись звонка',
  chat: 'Запись чата',
  delete: 'Удалить',
  delete_record: 'Удалить запись',
  record_will_deleted: 'Запись будет удалена',
  audoigramm: 'Аудиограмма',
  metric_list: 'Список рассчитанных метрик',
  metric: 'Метрика',
  metric_value: 'Значение',
  meta_data: 'Метаданные',
  client: 'Клиет',
  operator: 'Оператор',
  sec: 'сек',
  dialog: 'Диалог',
  link_copied: 'Ссылка на аудио скопирована!',
  translation_download_false: 'Ошибка загрузки',
  channels_meta_name: 'Имя',
  channels_meta_channel: 'Канал',
  channels_meta_gsm: 'Локация',
  metric_show_empty: 'Отображать пустые',
  end_dialog: 'Конец диалога',
  empty_dialog: 'Запись ещё не распознана',
  emotions: 'эмоции',
  chat_type: 'Сменить вид чата',
  monitoring: {
    hints: {
      monitoring_download: 'Скачать мониторинг',
      change_history: 'История изменений',
    },
    appeal_statuses: {
      CREATED: 'Апелляция: Создана',
      SENT: 'Апелляция: Отправлена',
      CLOSED: 'Апелляция: Закрыта',
      IN_WORK: 'Апелляция: На рассмотрении',
      DECLINED: 'Апелляция: Отклонена',
      ACCEPTED: 'Апелляция: Принята',
    },
    toasts: {
      nullable_val_err:
        'Невозможно завершить оценку, потому что не для всех критериев указаны значения.',
      success_appeal: 'Апелляция отправлена.',
      err_appeal: 'Апелляцию не удалось подать.',
      success_appeal_status: 'Статус апелляции успешно изменен.',
      err_appeal_status: 'Не удалось изменить статус.',
    },
    title: 'МФ: ',
    comment_placeholder: 'Напишите комментарий',
    comment_appeal_placeholder: 'Напишите комментарий для апелляции ..',
    score: 'Балл',
    approve: 'Завершить проверку',
    operator_approve: 'Подтвердить',
    approve_appeal: 'Подать апелляцию',
    send_appeal: 'Отправить апелляцию',
    cancel_appeal: 'Отменить',
    final_score: 'Итоговый балл',
    save_and_approve: 'Сохранить изменения и завершить проверку',
    save_and_approve_controller: 'Завершить проверку',
    no_value: 'Нет значения',
    appeal_approve_button: 'Подать апелляцию',
    appeal_cancel_button: 'Назад',
    appeal_input: 'Комментарий',
    table: {
      criteria: 'Критерий',
      value: 'Значение',
      metric_score: 'Значение метрики',
      score: 'Балл',
    },
    crit_mf: 'Крит. МФ',
    consider: 'Рассмотреть',
    resolution: 'Резолюция',
    resolution_err_operator: 'Ошибка оператора',
    resolution_err_controller: 'Ошибка контролёра',
    resolution_err_none: 'Нет ошибок сотрудников',
    refuse: 'Отказать',
    exit: 'Выйти',
    cancel: 'Отклонить',
    approve_and_save_appeal: 'Принять и сохранить изменения',
  },
  display: 'Отобразить',
  empty: 'пустые',
  hidden: 'скрытые',
  close: 'Закрыть',
  auto_scroll: 'Прокрутка текста',
};
